import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { CgClose } from 'react-icons/cg';
import _ from 'lodash';
import dynamic from 'next/dynamic';
import { BiArrowToRight } from 'react-icons/bi';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { SHOW_COMMEMORATE } from 'src/constants';
import type { NextPage } from 'next';

const WidgetSearchFullPage = dynamic(import('src/components/widgets/widget-search-full-page'));

function useOnClickOutside(ref: any, handler: any) {
  useEffect(() => {
    const listener = (event: { target: any }) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    document.addEventListener('mouseleave', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
      document.removeEventListener('mouseleave', listener);
    };
  }, [ref, handler]);
}
type Props = {
  handleToggle: any;
  data: any;
  gray?: boolean;
  sessionSevId?: any;
};
interface Prop {
  gray: boolean;
}
const NavDesktop: NextPage<Props> = ({ handleToggle, data }) => {
  const router = useRouter();
  const cid = router.asPath;
  const queryCid = router.query.cid;
  const [subToggle, setSubToggle]: any = useState({
    status: false,
    key: null
  });

  const subBoxRef: any = useRef();

  useOnClickOutside(subBoxRef, async () => {
    await setSubToggle({
      status: false,
      key: null
    });
  });

  return (
    <>
      <NavWrapper gray={SHOW_COMMEMORATE === 'true'}>
        <div className='menu'>
          <div className='nav-item'>
            <CgClose onClick={() => handleToggle('close', null)} />
            <WidgetSearchFullPage />
          </div>
          <ul className='nav-menu' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset' }}>
            <li className={`${cid === '/' ? '--active' : ''} active-menu-desktop`}>
              <a
                href='/'
                aria-label='nav-desktop'
                title='หน้าแรก'
                //! DATALAYER
                onClick={() =>
                  sendDataLayerGlobal({
                    type: DATALAYER_TYPE.TRACK,
                    router: router?.pathname,
                    section: 'menubar',
                    data: {
                      title: 'หน้าแรก',
                      heading: 'หน้าแรก'
                    }
                  })
                }
              >
                <span> home </span>
              </a>
            </li>
            {!_.isEmpty(data) &&
              data.map((menu: any, index: any) => (
                <li
                  key={index}
                  className={`${cid === `/${menu?.link}` || queryCid === menu?.nameEng ? '--active' : ''} active-menu-desktop`}
                  onMouseLeave={() => setSubToggle({ status: false, key: null })}
                >
                  <a
                    href={`/${menu?.link}`}
                    onMouseOver={() => setSubToggle({ status: true, key: index })}
                    onFocus={() => {}}
                    title={menu?.nameTh}
                    //! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK,
                        router: router?.pathname,
                        section: 'menubar',
                        data: {
                          title: menu?.nameTh,
                          heading: menu?.nameTh
                        }
                      })
                    }
                  >
                    <span> {menu?.nameTh} </span>
                    {menu?.sub.length > 0 && <BiArrowToRight />}
                  </a>
                  {/* --------------------------------- SUBMENU -------------------------------- */}
                  {subToggle?.key === index && subToggle?.status && menu?.sub.length > 0 && (
                    <ul className='nav-sub-menu' ref={subBoxRef} onMouseLeave={() => setSubToggle({ key: null, status: false })}>
                      <CardSubMenuStyle>
                        <div className='card-sub-menu'>
                          <ul>
                            {!_.isEmpty(menu?.sub) &&
                              menu.sub.map((subMenu: any, index: any) => (
                                <li key={index} aria-hidden='true'>
                                  <a
                                    href={subMenu.link}
                                    title={subMenu.nameTh}
                                    //! DATALAYER
                                    onClick={() =>
                                      sendDataLayerGlobal({
                                        type: DATALAYER_TYPE.TRACK,
                                        router: router?.pathname,
                                        section: 'menubar',
                                        data: {
                                          title: subMenu?.nameTh,
                                          heading: `${menu?.nameTh}:${subMenu?.nameTh}`
                                        }
                                      })
                                    }
                                  >
                                    {subMenu?.nameTh}
                                  </a>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </CardSubMenuStyle>
                    </ul>
                  )}
                </li>
              ))}
            <li className={`${cid === '/about-us' ? '--active' : ''} active-menu-desktop`}>
              <a
                href='/about-us'
                aria-label='nav-desktop'
                title='about'
                //! DATALAYER
                onClick={() =>
                  sendDataLayerGlobal({
                    type: DATALAYER_TYPE.TRACK,
                    router: router?.pathname,
                    section: 'menubar',
                    data: {
                      title: 'about',
                      heading: 'about'
                    }
                  })
                }
              >
                <span> about </span>
                <BiArrowToRight />
              </a>
            </li>
          </ul>
        </div>
      </NavWrapper>
    </>
  );
};

const NavWrapper = styled.div<Prop>`
  position: fixed;
  text-transform: uppercase;
  top: 0;
  width: 290px;
  max-width: 100%;
  height: 100vh;
  background-color: #fff;
  z-index: 20;
  //box-shadow: 1px 0px 10px 0px rgba(237,26,59,0.3);
  box-shadow: ${props => (props?.gray ? 'gray' : '1px 0px 10px 0px rgba(237,26,59,0.3);')};
  .active-menu-desktop {
    position: relative;
    a {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .nav-sub-menu {
      left: 100%;
      top: 0;
    }
  }
  .nav-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #4e4e4e1a;
    svg {
      filter: ${props => (props?.gray ? 'grayscale(1)' : 'unset')};
      color: rgba(237, 26, 59, 1);
      font-size: 28px;
      cursor: pointer;
    }
  }
  /* ------------------------------- DESKTOP : Navigation Menu -------------------------------- */
  ul.nav-menu {
    list-style-type: none;
    display: flex;
    flex-direction: column;

    li.active-menu,
    .active-menu-desktop {
      padding: 10px 15px;
      &:hover {
        background: rgba(237, 26, 59);
        span,
        svg {
          color: rgba(255, 255, 255);
        }
      }
      &.--active {
        background: rgba(237, 26, 59);
        span,
        svg {
          color: rgba(255, 255, 255);
        }
      }
      a {
        span {
          font-weight: 500;
          font-size: 15px;
          line-height: 16px;
          vertical-align: middle;
          color: #212121;
        }
        svg {
          font-size: 20px;
          margin: 0px 0px -5px 10px;
        }
      }
    }
  }

  /* ---------------------------- DESKTOP : Navigation SubMenu ------------------------------ */
  ul.nav-sub-menu {
    background: rgb(255, 255, 255);
    width: 100%;
    position: absolute;
    visibility: visible;
    z-index: 2;
    padding: 0px;
    margin: 0px;
    opacity: 1;
    transition: all 0.3s ease-out;
    transform-origin: 0 0 0;
    /* box-shadow: #ed1a3b 0px 10px 10px -10px; */
    box-shadow: 5px 0px 10px 0px rgba(237, 26, 59, 0.3);
    a {
      font-size: 14px;
      font-weight: 300;
      display: block;
      text-transform: uppercase;
      transition: all 0.5s ease-out;
    }
  }
`;

const CardSubMenuStyle = styled.div`
  position: relative;
  .card-sub-menu {
    padding: 15px 25px 15px 15px;
    ul {
      overflow: hidden scroll;
      height: 178px;
      list-style: none;
      padding: 0;
      display: block;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: rgb(0, 0, 0, 0.5);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: rgb(247, 247, 247, 0.2);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #ed1a3b;
      }

      li {
        padding: 5px;
        border-radius: 3px;
        margin-bottom: 16px;
        margin-left: 0;
        text-align: left;
        border: 2px;
        a {
          color: #000;
          &:hover {
            padding-left: 16px;
            color: #ed1a3b;
          }
        }
        i {
          float: right;
          color: transparent;
        }
        &:hover {
          color: #ed1a3b;
          border: unset;
          i {
            color: #ed1a3b;
          }
        }
      }
    }
  }
`;

export default NavDesktop;
